import { useState, useEffect } from "react";
import axiosInstance from '../../../Config/axiosInstance';
import {Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, MenuItem, Button, Grid, 
    Typography, CircularProgress, Alert, Box, Menu, ListItemIcon, ListItemText, OutlinedInput, Select, Checkbox, FormControl, 
    InputLabel} from '@mui/material';
import { Save, PictureAsPdf, GetApp, Assessment} from '@mui/icons-material';
import './ProjectExpenses.css';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from 'exceljs';
import {saveAs} from "file-saver";
import logoImg from '../../../Images/logo_pmpc.png'


const ProjectExpenses = () => {
    const [filters, setFilters] = useState({
        year: new Date().getFullYear(),
        clients: ['ALL'],
        suppliers: ['ALL']
    });

    const [clientsOptions, setClientsOptions] = useState([
        { value: 'ALL', label: 'All Clients' } 
    ]);
    const [suppliersOptions, setSuppliersOptions] = useState([
        { value: 'ALL', label: 'All Suppliers' }
    ]);

    const [internalResources, setInternalResources] = useState([])
    
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [error, setError] = useState('');
    const [reportGenerated, setReportGenerated] = useState(false);

    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 8 }, (_, i) => currentYear - 2 + i);
    

    useEffect(() => {
        setLoadingOptions(true);
        
        axiosInstance
            .get('/clients/')
            .then((response) => {
                const formattedClients = response.data.map(item => ({
                    value: item.name,
                    label: item.name,
                }))
                setClientsOptions([{ value: 'ALL', label: 'All Clients' }, ...formattedClients ]);
            })
            .catch((error) => {
                console.error('Error fetching clients')
            });

        axiosInstance
            .get('/suppliers/')
            .then((response) => {
                const formattedClients = response.data.map(item => ({
                    value: item.name,
                    label: item.name,
                }))
                setSuppliersOptions([{ value: 'ALL', label: 'All Suppliers' }, ...formattedClients ]);
            })
            .catch((error) => {
                console.error('Error fetching suppliers')
            });

        setLoadingOptions(false);
    }, []);

    const handleFilterChange = (field, value) => {
        if (field === 'clients') {
            const allClients = clientsOptions
                .filter(opt => opt.value !== 'ALL')
                .map(opt => opt.value);

            // la click pe ALL
            if (value.includes('ALL')) {
                // daca ALL era deja selectat, deselectează tot
                if (filters.clients.includes('ALL')) {
                    setFilters(prev => ({ ...prev, clients: [] }));
                } 
                // altfel selecteaza tot
                else {
                    setFilters(prev => ({ ...prev, clients: ['ALL'] }));
                }
                return;
            }

            // selectie manuala
            if (value.length === allClients.length) {
                // toate bifate manual atunci marchează ALL
                setFilters(prev => ({ ...prev, clients: ['ALL'] }));
            } else {
                setFilters(prev => ({ ...prev, clients: value }));
            }

            setReportGenerated(false);
            return;
        }


        if (field === 'suppliers') {
            const allSuppliers = suppliersOptions
                .filter(opt => opt.value !== 'ALL')
                .map(opt => opt.value);

            // la click pe ALL
            if (value.includes('ALL')) {
                // daca ALL era deja selectat, deselectează tot
                if (filters.suppliers.includes('ALL')) {
                    setFilters(prev => ({ ...prev, suppliers: [] }));
                } 
                // altfel selecteaza tot
                else {
                    setFilters(prev => ({ ...prev, suppliers: ['ALL'] }));
                }
                return;
            }

            // selectie manuala
            if (value.length === allSuppliers.length) {
                // toate bifate manual atunci marchează ALL
                setFilters(prev => ({ ...prev, suppliers: ['ALL'] }));
            } else {
                setFilters(prev => ({ ...prev, suppliers: value }));
            }

            setReportGenerated(false);
            return;
        }


        if (field === 'year') {
            setFilters(prev => ({
                ...prev,
                year: value,
            }));
            setReportGenerated(false);
            return;
        }        
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (filters.clients.length === 0) {
            setError('Please select at least one Client.');
            setReportGenerated(false);
            setReportData(null);
            return;
        }

        if (filters.suppliers.length === 0) {
            setError('Please select at least one Supplier.');
            setReportGenerated(false);
            setReportData(null);
            return;
        }

        setLoading(true);
        setError('');

        try {
            const params = {
                year: filters.year,
                clients: filters.clients,
                suppliers: filters.suppliers,
            };

            if (filters.clients.includes('ALL')) {
                params.clients = ['ALL'];
            } else if (filters.clients.length === 1)
                params.clients = filters.clients;

            if (filters.suppliers.includes('ALL')) {
                params.suppliers = ['ALL'];
            } else if (filters.suppliers.length === 1)
                params.suppliers = filters.suppliers;

            console.log(params)

            const response = await axiosInstance.get('/project-expenses/', { params: params });
            setReportData(response.data);
            console.log(response.data);
            setInternalResources(getAllInternalResources(response.data))
            setReportGenerated(true);

        } catch (err) {
            setError(err.response?.data?.error || 'Failed to generate report');
            setReportData(null);
            setReportGenerated(false);
        } finally {
            setLoading(false);
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const formatNumber = (num) => {
        if (num == null || num === undefined) return '0.00';
        return new Intl.NumberFormat('en-EN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const getAllInternalResources = (data) => {

        console.log(data)
        console.log(data.internal_costs)
        console.log(Array.isArray(data.internal_costs))

        if (!data || !data.internal_costs || !Array.isArray(data.internal_costs)) {
            return [];
        }
        
        const allResources = new Set();
        
        data.internal_costs.forEach((ir) => {
        if (ir.costs && typeof ir.costs === 'object') {
            Object.keys(ir.costs).forEach(resource => {
                allResources.add(resource);
            });
        }
        });
        
        const resourcesArray = Array.from(allResources).sort();
        if (resourcesArray.length === 0)
            return [ "" ]
        else return resourcesArray;
    };

    const findInternalCost = ( internal_costs, code, type ) => {
        console.log(internal_costs)
        const project = internal_costs.find(item => item.project_code === code);

        return project?.costs?.[type] ?? 0.00
    }

    const exportToExcel = async () => {
        if (!reportData || !reportData.reports || reportData.reports.length === 0) {
            alert('No data to export!');
            return;
        }
        
        try {
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet('Report');

            const totalColumns = 2 + internalResources.length + 2;
            sheet.mergeCells('A1:B4');
            
            const lastColumnLetter = String.fromCharCode(65 + totalColumns - 1);
            sheet.mergeCells(`C1:${lastColumnLetter}4`);
            
            //logo
            try {
                const response = await fetch(logoImg);
                const imageBuffer = await response.arrayBuffer();
                
                const imageId = workbook.addImage({
                    buffer: imageBuffer,
                    extension: 'png',
                });
                
                sheet.addImage(imageId, {
                    tl: { col: 0, row: 0 },
                    br: { col: 2, row: 4 }
                });
            } catch (error) {
                console.warn('Logo could not be loaded:', error);
            }

            const titleCell = sheet.getCell('C1');
            titleCell.value = 'Project Expenses';
            titleCell.font = { size: 16, bold: true };
            titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
            sheet.addRow([]);

            console.log(reportData.clients)

            sheet.addRow(['Year:', reportData.year || '']);
            sheet.addRow([`Clients:`, reportData.clients || '']);
            sheet.addRow([`Suppliers:`, reportData.suppliers || '']);
            sheet.addRow([]);

            //header pentru primul tabel
            const headers = [
            'Project Code',
            'Project Description',
            ...internalResources.map(resource => `Internal Cost ${resource}`),
            'External Cost',
            'Additional Cost',
            'Total Cost per Project'
            ];
            
            // ...internalResources.map(resource => formatNumber(findInternalCost(reportData.internal_costs, project.code, resource)))

            const headerRow = sheet.addRow(headers);
            headerRow.font = { bold: true };
            headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
            headerRow.height = 25;
            
            for (let i = 1; i <= headers.length; i++) {
                headerRow.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE8E8E8' }
                };
            }

            reportData.reports.forEach((row) => {
                const rowData = [
                    row.code,
                    row.description,
                    ...internalResources.map(resource => formatNumber(findInternalCost(reportData.internal_costs, row.code, resource))),
                    formatNumber(row.external_cost || 0),
                    formatNumber(row.additional_cost || 0),
                    formatNumber(row.total_cost || 0)
            ];
            
            const dataRow = sheet.addRow(rowData);
            
            internalResources.forEach((_, index) => {
                const cell = dataRow.getCell(3 + index);
                cell.numFmt = '#,##0.00';
                cell.alignment = { horizontal: 'right' };
            });
            
            const externalCell = dataRow.getCell(3 + internalResources.length);
            externalCell.numFmt = '#,##0.00';
            externalCell.alignment = { horizontal: 'right' };

            const additionalCell = dataRow.getCell(4 + internalResources.length);
            additionalCell.numFmt = '#,##0.00';
            additionalCell.alignment = { horizontal: 'right' };
            
            const totalCell = dataRow.getCell(5 + internalResources.length);
            totalCell.numFmt = '#,##0.00';
            totalCell.font = { bold: true };
            totalCell.alignment = { horizontal: 'right' };
            });

            sheet.addRow([]);
            
            const totalAdditional = formatNumber(reportData?.total_additional_cost || 0);
            const totalInternal = formatNumber(reportData?.total_internal_cost || 0);
            const totalExternal = formatNumber(reportData?.total_external_cost || 0);
            const grandTotal = formatNumber(reportData?.grand_total_cost || 0);

            const totalsRowData = ['', ''];
            
            
            for (let i = 0; i < internalResources.length; i++) {
                if (i === 0) {
                    totalsRowData.push(`Total Internal Cost: \n${totalInternal}`);
                } else {
                    totalsRowData.push(''); 
                }
            }
            
            totalsRowData.push(`Total External Cost: \n${totalExternal}`);
            totalsRowData.push(`Total Additional Cost: \n${totalAdditional}`);
            totalsRowData.push(`Total Cost all Project: \n${grandTotal}`);

            const totalsRow = sheet.addRow(totalsRowData);
            totalsRow.font = { bold: true };
            const lastColumnWithValue = totalsRowData.length;
            
            for (let colIndex = 1; colIndex <= lastColumnWithValue; colIndex++) {
            totalsRow.getCell(colIndex).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFCDF5E0' }
            };
            }
            
            totalsRow.getCell(1).alignment = {
                wrapText: true,
                vertical: 'middle',
                horizontal: 'center'
            };
            
            const valueCells = [
                2, 
                3, 
                2 + internalResources.length + 1,    
                2 + internalResources.length + 2,
                2 + internalResources.length + 3,
            ];
            
            valueCells.forEach(cellIndex => {
            const cell = totalsRow.getCell(cellIndex);
            cell.alignment = { 
                wrapText: true,
                vertical: 'middle',
                horizontal: 'center'
            };
            cell.numFmt = '#,##0.00';
            });
            
            for (let colIndex = 4; colIndex < 2 + internalResources.length + 1; colIndex++) {
            const cell = totalsRow.getCell(colIndex);
            if (cell.value === '') {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            }
            }
            
            totalsRow.height = 40;
            
            sheet.columns.forEach((column, columnIndex) => {
                let columnWidth;
                
                if (columnIndex === 0) {
                    columnWidth = 25
                } else if (columnIndex === 1) {
                    columnWidth = 50
                } else if (columnIndex >= 2 && columnIndex < 2 + internalResources.length) {
                    columnWidth = 20
                } else if (columnIndex === 2 + internalResources.length) {
                    columnWidth = 20
                } else if (columnIndex === 2 + internalResources.length + 1) {
                    columnWidth = 20
                } else if (columnIndex === 2 + internalResources.length + 2) {
                    columnWidth = 20
                } else {
                    columnWidth = 12
                }
                
                columnWidth = Math.min(columnWidth, 25);
                column.width = columnWidth;
            });
            
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            
            const fileName = `ProjectExpenses_${reportData.year}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            
            if (typeof saveAs !== 'undefined') {
            saveAs(blob, fileName);
            }
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            alert('Error exporting to Excel. Please try again.');
        }
    };

    const exportPDF = async () => {
        if (!reportData || !reportData.reports || reportData.reports.length === 0) {
            alert('No data to export!');
            return;
        }
        
        //pdf portrait
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const logo = "/logo_pmpc.png";

        //logo
        pdf.addImage(logo, "PNG", 8, 3, 28, 8);

        //dimensiuni elemente decorative
        const triangleWidth = 20;
        const totalWidth = pdfWidth * 0.25;
        const barWidth = totalWidth - triangleWidth;

        const barHeight = 1.2;     // bara scurtă + triunghi
        const secondBarHeight = 2; // bara lungă
        const barTop = 15;
        const barBottom = barTop + barHeight;

        //bara scurta
        pdf.setFillColor(23, 52, 88);
        const barOverlap = 1;
        pdf.rect(0, barTop, barWidth + barOverlap, barHeight, "F");

        //triunghi
        pdf.triangle(
        barWidth, barBottom,                 
        barWidth + triangleWidth, barBottom,  
        barWidth, barTop,                   
        "F"
        );

        //suprapunere 
        const overlap = 0.6;
        const headerLongBarTop = barBottom - overlap;

        //bara lunga full-width (header)
        pdf.rect(0, headerLongBarTop, pdfWidth, secondBarHeight, "F");

        const dottedLineY = headerLongBarTop + secondBarHeight;
        //titlu
        const reportTitle = `Project Expenses`;

        pdf.setFontSize(14);
        pdf.setFont("helvetica", "bold");
        pdf.text(reportTitle, pdfWidth / 2, dottedLineY + 12, {align: "center"});

        // detalii

        const year = `Year: ${reportData.year}`
        const clients = `Clients: ${reportData.clients}`;
        const suppliers = `Suppliers: ${reportData.suppliers}`;

        pdf.setFontSize(11);
        pdf.setFont("helvetica", "normal");
        pdf.text(year, 5, dottedLineY + 18, {align: "left"});
        
        pdf.setFontSize(11);
        pdf.setFont("helvetica", "normal");
        pdf.text(clients, 5, dottedLineY + 24, {align: "left"});

        pdf.setFontSize(11);
        pdf.setFont("helvetica", "normal");
        pdf.text(suppliers, 5, dottedLineY + 30, {align: "left"});

        const contentTop = dottedLineY + 36;
        let currentY = contentTop;

        //calculeaza latimile coloanelor
        const numInternalResources = internalResources.length;
        const numColumns = 2 + numInternalResources + 3;
        
        const availableWidth = pdfWidth - 20;
        const columnWidth = availableWidth / numColumns;
        
        //configuratie coloane
        const columnStyles = {
            0: { cellWidth: columnWidth * 1.1 },
            1: { cellWidth: columnWidth * 1.2 }, 
        };
        
        //resurse interne
        for (let i = 2; i < 2 + numInternalResources; i++) {
            columnStyles[i] = { cellWidth: columnWidth, halign: 'right' };
        }
        
        //ultimele 3 coloane
        columnStyles[2 + numInternalResources] = { cellWidth: columnWidth, halign: 'right' }; // External
        columnStyles[3 + numInternalResources] = { cellWidth: columnWidth, halign: 'right' }; // Additional
        columnStyles[4 + numInternalResources] = { cellWidth: columnWidth, halign: 'right', fontStyle: 'bold' }; // Total

        //headers pentru tabel
        const tableHeaders = [
            ["Project Code", "Project Description", 
            ...internalResources.map(resource => `Internal Cost\n${resource}`), 
            "External Cost", "Additional Cost", "Total Cost\nper Project"]
        ];

        const tableData = reportData.reports.map(project => {
            return [
                project.code,
                project.description,
                ...internalResources.map(resource => formatNumber(findInternalCost(reportData.internal_costs, project.code, resource))),
                formatNumber(project.external_cost),
                formatNumber(project.additional_cost),
                formatNumber(project.total_cost),
            ];
        });

        //adauga primul tabel
        autoTable(pdf, {
          startY: currentY,
          head: tableHeaders,
          body: tableData,
          styles: {
              fontSize: 8,
              cellPadding: 2,
              overflow: "linebreak",
              lineColor: [180, 180, 180],
              lineWidth: 0.25,
              valign: "middle",
              textColor: [0, 0, 0],
              minCellHeight: 6
          },
          headStyles: {
              fillColor: [232, 232, 232],
              textColor: 0, 
              fontStyle: "bold",
              halign: "center",
              valign: "middle"
          },
          columnStyles: columnStyles,
          alternateRowStyles: {
              fillColor: [245, 247, 250]
          },
          margin: {left: 5, right: 5},
          tableWidth: 'auto',
          theme: 'grid',
          didParseCell: function(data) {
              if (data.section === 'body') {
                  if (data.column.index >= 2) {
                      data.cell.styles.halign = 'right';
                  }
              }
          },
          didDrawPage: function(data) {
              if (data.cursor) {
                  currentY = data.cursor.y;
              }
          }
      });
      
      currentY = pdf.lastAutoTable.finalY;

        const totalAdditional = formatNumber(reportData?.total_additional_cost || 0);
        const totalInternal = formatNumber(reportData?.total_internal_cost || 0);
        const totalExternal = formatNumber(reportData?.total_external_cost || 0);
        const grandTotal = formatNumber(reportData?.grand_total_cost || 0);

        //creaza randul cu totaluri
        const totalsRow = ['', ''];
        
        for (let i = 0; i < numInternalResources; i++) {
            if (i === 0) {
                totalsRow.push(`Total Internal Cost:\n${totalInternal}`);
            } else {
                totalsRow.push(''); 
            }
        }

        totalsRow.push(`Total External Cost:\n${totalExternal}`);
        totalsRow.push(`Total Additional Cost:\n${totalAdditional}`);
        totalsRow.push(`Total Cost All Project:\n${grandTotal}`);        

        //adauga randul cu totaluri
        autoTable(pdf, {
            startY: currentY,
            body: [totalsRow],
            styles: {
                fontSize: 9,
                cellPadding: 2,
                lineColor: [180, 180, 180],
                lineWidth: 0.25,
                valign: "middle",
                textColor: [0, 0, 0],
                fillColor: [205, 245, 224] 
            },
            columnStyles: columnStyles,
            margin: {left: 5, right: 5},
            tableWidth: 'auto',
            theme: 'grid',
            didParseCell: function(data) {
                if (data.column.index > 0) {
                    data.cell.styles.halign = 'center';
                    data.cell.styles.valign = 'middle';
                }
            }
        });

        //footer pentru toate paginile
        const totalPages = pdf.internal.getNumberOfPages();
        
        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            
            pdf.setFillColor(23, 52, 88);

            const bottomOffset = 12; 
            const longBarTop = pdfHeight - bottomOffset; 

            //suprapunere
            const verticalOverlapFooter = 0.6;

            //bara lunga jos
            pdf.rect(
            0,
            longBarTop - verticalOverlapFooter + 0.1,
            pdfWidth,
            secondBarHeight,
            "F"
            );

            //bara scurta + triunghi
            const shortBarTop = longBarTop + secondBarHeight - verticalOverlapFooter;
            const shortBarBottom = shortBarTop + barHeight;

            //bara scurta 
            const barOverlapFooter = 1;
            pdf.rect(
            0,
            shortBarTop,
            barWidth + barOverlapFooter,
            barHeight,
            "F"
            );

            //triunghiul din partea dreapta jos
            pdf.triangle(
            barWidth, shortBarTop,                    
            barWidth + triangleWidth, shortBarTop,        
            barWidth, shortBarBottom,                      
            "F"
            );

            //pagina curenta/ total pagini
            pdf.setFontSize(7);
            pdf.setFont("helvetica", "normal");
            pdf.text("Generated by PMPC ERP", 10, pdfHeight - 3);
            const today = new Date();
            const currentDate = today.toLocaleDateString("ro-RO");
            pdf.text(`${currentDate} `, pdfWidth - 30, pdfHeight - 3);

            pdf.text(`Page ${i} of ${totalPages}`, pdfWidth / 2, pdfHeight - 3, { align: "center" });
        }

        //save pdf
        pdf.save(`ProjectExpenses_${reportData.year}_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    return (
        <Container maxWidth={false} disableGutters className="proj-report project-report">
            <Container maxWidth={false} disableGutters className="project-container">
                <Typography variant="h4" gutterBottom marginTop="20px">
                    Project Expenses
                </Typography>
                
                <Paper className="filters-paper" sx={{ p: 2 }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={9}>
                                <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>

                                    <TextField
                                        select 
                                        label="Year"
                                        value={filters.year}
                                        onChange={(e) => handleFilterChange('year', e.target.value)}
                                        required
                                        size="small"
                                        className="year-select"
                                    >
                                        {yearOptions.map((year) => (
                                            <MenuItem key={year} value={year}>
                                                {year}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    

                                    <FormControl 
                                        size="small" 
                                        className="project-code-select"
                                        sx={{ minWidth: 180 }}
                                        disabled={loadingOptions || clientsOptions.length === 0}
                                    >
                                        <InputLabel>Clients</InputLabel>
                                        <Select
                                            multiple
                                            value={filters.clients}
                                            onChange={(e) => handleFilterChange('clients', e.target.value)}
                                            input={<OutlinedInput label="Clients" />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return 'Select Clients';
                                                }
                                                if (selected.includes('ALL')) {
                                                    return 'All Clients';
                                                }
                                                if (selected.length > 1) {
                                                    return `${selected.length} clients selected`;
                                                }
                                                return selected.join(', ');
                                            }}
                                             MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                    width: 250,
                                                    '& .MuiMenuItem-root': {
                                                        fontSize: '0.75rem',
                                                        paddingTop: 0.25,
                                                        paddingBottom: 0.25,
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                    },
                                                    '& .MuiCheckbox-root': {
                                                        padding: '2px',
                                                        marginRight: '4px',
                                                    },
                                                    },
                                                },
                                            }}
                                            >
                                            {clientsOptions.length > 0 ? (
                                                clientsOptions.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox
                                                            checked={
                                                                option.value === 'ALL'
                                                                    ? filters.clients.includes('ALL')
                                                                    : filters.clients.includes('ALL') ||
                                                                    filters.clients.includes(option.value)
                                                            }
                                                        />
                                                        <ListItemText primary={option.label} />
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>
                                                    <ListItemText 
                                                        primary={loadingOptions ? "Loading..." : "No clients available"} 
                                                    />
                                                </MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>

                                    <FormControl 
                                        size="small" 
                                        className="project-code-select"
                                        sx={{ minWidth: 180 }}
                                        disabled={loadingOptions || suppliersOptions.length === 0}
                                    >
                                        <InputLabel>Suppliers</InputLabel>
                                        <Select
                                            multiple
                                            value={filters.suppliers}
                                            onChange={(e) => handleFilterChange('suppliers', e.target.value)}
                                            input={<OutlinedInput label="Suppliers" />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return 'Select Suppliers';
                                                }
                                                if (selected.includes('ALL')) {
                                                    return 'All Suppliers';
                                                }
                                                if (selected.length > 1) {
                                                    return `${selected.length} suppliers selected`;
                                                }
                                                return selected.join(', ');
                                            }}
                                             MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                    width: 250,
                                                    '& .MuiMenuItem-root': {
                                                        fontSize: '0.75rem',
                                                        paddingTop: 0.25,
                                                        paddingBottom: 0.25,
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                    },
                                                    '& .MuiCheckbox-root': {
                                                        padding: '2px',
                                                        marginRight: '4px',
                                                    },
                                                    },
                                                },
                                            }}
                                            >
                                            {suppliersOptions.length > 0 ? (
                                                suppliersOptions.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox
                                                            checked={
                                                                option.value === 'ALL'
                                                                    ? filters.suppliers.includes('ALL')
                                                                    : filters.suppliers.includes('ALL') ||
                                                                    filters.suppliers.includes(option.value)
                                                            }
                                                        />
                                                        <ListItemText primary={option.label} />
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>
                                                    <ListItemText 
                                                        primary={loadingOptions ? "Loading..." : "No suppliers available"} 
                                                    />
                                                </MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>

                                    <Button 
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="generate-button"
                                        startIcon={loading ? <CircularProgress size={20} /> : <Assessment />}
                                        disabled={loadingOptions || loading}
                                    >
                                        {loading ? 'Generating...' : 'Generate Report'}
                                    </Button>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <Grid container spacing={1} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleClick}
                                            className="save-button"
                                            startIcon={<Save />}
                                            disabled={!reportGenerated}
                                        >
                                            Save As
                                        </Button>
                                    </Grid>
                                </Grid>

                                <Menu 
                                    anchorEl={anchorEl} 
                                    open={Boolean(anchorEl)} 
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={() => {
                                        exportPDF();
                                        handleClose();
                                    }}>
                                        <ListItemIcon><PictureAsPdf fontSize="small" /></ListItemIcon>
                                        <ListItemText>Save as PDF</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() =>{
                                        exportToExcel();
                                        handleClose();
                                    }}>
                                        <ListItemIcon><GetApp fontSize="small" /></ListItemIcon>
                                        <ListItemText>Save as Excel</ListItemText>
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        </Grid>

                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                {error}
                            </Alert>
                        )}

                        {filters.clients.length > 1 && !filters.clients.includes('ALL') && (
                            <Box mt={2}>
                                <Typography variant="caption" color="text.secondary">
                                    Selected clients:
                                </Typography>
                                <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
                                    {filters.clients.map(client => (
                                        <Box
                                            key={client}
                                            sx={{
                                                px: 1,
                                                py: 0.25,
                                                borderRadius: 1,
                                                backgroundColor: '#e3f2fd',
                                                fontSize: '0.75rem',
                                                fontWeight: 500
                                            }}
                                        >
                                            {client}
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        )}

                        {filters.suppliers.length > 1 && !filters.suppliers.includes('ALL') && (
                            <Box mt={2}>
                                <Typography variant="caption" color="text.secondary">
                                    Selected suppliers:
                                </Typography>
                                <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
                                    {filters.suppliers.map(supplier => (
                                        <Box
                                            key={supplier}
                                            sx={{
                                                px: 1,
                                                py: 0.25,
                                                borderRadius: 1,
                                                backgroundColor: '#e3f2fd',
                                                fontSize: '0.75rem',
                                                fontWeight: 500
                                            }}
                                        >
                                            {supplier}
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </form>
                </Paper>

                {reportData && reportGenerated && (
                    <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 3 }}>

                    <Paper sx={{ p: 2 }}>

                        <Typography variant="subtitle1" color="textSecondary">
                            Year: {reportData.year}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary">
                            Clients: {reportData.clients}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary">
                            Suppliers: {reportData.suppliers}
                        </Typography>

                        <Typography variant="subtitle1" color="textSecondary">
                            ---
                        </Typography>

                        {reportData.count > 0 && reportData.reports && reportData.reports.length > 0 ? (
                        <TableContainer className="report-table-container">
                            <Table size="small" sx={{ tableLayout: 'fixed' }}>
                            <TableHead>
                                <TableRow className="table-header">
                                <TableCell className="table-header-cell">Project Code</TableCell>
                                <TableCell className="table-header-cell">Project Description</TableCell>
                                {internalResources.map((resource, index) => (
                                    <TableCell key={index} className="table-header-cell" align="center">
                                        {`Internal Cost ${resource}`}
                                    </TableCell>
                                ))}
                                <TableCell className="table-header-cell" align="center">External Cost</TableCell>
                                <TableCell className="table-header-cell" align="center">Additional Cost</TableCell>
                                <TableCell className="table-header-cell" align="center">Total Cost per Project</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.reports.map((report) => (
                                <TableRow
                                    key={report.code}
                                    hover
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell sx={{ width: '15%' }}>{report.code}</TableCell>
                                    <TableCell sx={{ width: '15%' }}>{report.description}</TableCell>
                                    {internalResources.map((resource, idx) => (
                                        <TableCell key={idx} align="center" sx={{ width: '15%' }}>
                                        {formatNumber(findInternalCost(reportData.internal_costs, report.code, resource))}
                                        </TableCell>
                                    ))}
                                    <TableCell sx={{ width: '15%' }} align="center">{formatNumber(report.external_cost)}</TableCell>
                                    <TableCell sx={{ width: '15%' }} align="center">{formatNumber(report.additional_cost)}</TableCell>
                                    <TableCell sx={{ width: '15%' }} align="center">{formatNumber(report.total_cost)}</TableCell>
                                </TableRow>
                                ))}

                                <TableRow sx={{ backgroundColor: '#cdf5e0ff' }}>
                                    <TableCell colSpan={2}>
                                        <Typography fontWeight="bold"></Typography>
                                    </TableCell>

                                    <TableCell colSpan={internalResources.length}>
                                        <Typography variant="body2">Total Internal Cost:</Typography>
                                        <Typography fontWeight="bold">
                                            {formatNumber(reportData?.total_internal_cost)}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Typography variant="body2">Total External Cost:</Typography>
                                        <Typography fontWeight="bold">
                                        {formatNumber(reportData?.total_external_cost)}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Typography variant="body2">Total Additional Cost:</Typography>
                                        <Typography fontWeight="bold">
                                        {formatNumber(reportData?.total_additional_cost)}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Typography variant="body2">Total Cost All Project:</Typography>
                                        <Typography fontWeight="bold">
                                        {formatNumber(reportData?.grand_total_cost)}
                                        </Typography>
                                    </TableCell>
                                    </TableRow>
                            </TableBody>
                            </Table>
                        </TableContainer>
                        ) : (
                        <Alert severity="info" sx={{ mt: 2 }}>
                            No report data available.
                        </Alert>
                        )}
                    </Paper>
                    </Box>
                    </>
                )}
            </Container>
            {reportData && reportGenerated && (
                <Box className="report-footer">
                    <Typography variant="caption" className="footer-text">
                        Generated on {reportData.report_date || new Date().toLocaleString('ro-RO')} |{' '}
                        {filters.year} |{' '}
                        Clients: {filters.clients.includes('ALL') 
                            ? 'All Clients'
                            : filters.clients.length > 0
                                ? (filters.clients.length > 3 
                                    ? `${filters.clients.length} clients selected`
                                    : filters.clients.join(', '))
                                : 'None selected'
                        } |{' '}
                        Suppliers: {filters.suppliers.includes('ALL') 
                            ? 'All Suppliers'
                            : filters.suppliers.length > 0
                                ? (filters.suppliers.length > 3 
                                    ? `${filters.suppliers.length} suppliers selected`
                                    : filters.suppliers.join(', '))
                                : 'None selected'
                        }
                    </Typography>
                </Box>
            )}
        </Container>
    );
};

export default ProjectExpenses;